module.exports = window.CodeMirror;